export default '/build/127e54a3.svg'